export class InvoiceListTotalAmount {
  fromObject(object: any): InvoiceListTotalAmount {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public invoicesTotal: number;
  public mismatchedInvoicesCount: number;
}
